import './SelectIconItem.css'
import { Radio } from '../RadioGroup/RadioGroup'
import cx from 'classnames'

export function SelectIconItem<T extends string | boolean | number>({
  id,
  isChecked,
  name,
  value,
  title,
  description,
  icon,
  className,
  onChange
}: {
  id: string
  isChecked: boolean
  className?: string
  title: string
  description?: string
  name: string
  icon: React.ReactNode
  value: T
  onChange: (value: T) => void
}) {
  return (
    <label htmlFor={id} className={cx('select-icon-item', className)}>
      <div>
        <Radio id={id} value={value} name={name} isChecked={isChecked} onChange={onChange} />
      </div>
      <div className="select-icon-item-icon">{icon}</div>
      <div>
        <h3 className="font-semibold">{title}</h3>
        <h4 className="select-icon-item-description">{description}</h4>
      </div>
    </label>
  )
}
